// export const IP = 'https://3.109.161.181/'
export const IP = 'https://www.salescrm123.in/'
// export const IP = 'http://localhost/'
